var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor"},[_c('div',{ref:"toolbar",staticClass:"toolbar"}),_c('div',{ref:"editor",staticClass:"text"}),_c('el-button',{staticClass:"uploadButton",attrs:{"type":"danger"},on:{"click":_vm.upload}},[_vm._v("请先保存内容")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }